




























































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from "vue-property-decorator";
import HomeFooter from "@/components/footer.vue";
import HomeHeader from "@/components/header.vue";
import PaypalCheckout from "@/components/paypalCheckout.vue";
import { ProductService } from "../services/productService";
import RegisterButton from "@/components/customActions/registerButton.vue";
import { User } from "../interfaces/user";
import Product from "../interfaces/product";

@Component({
    components: { HomeFooter, HomeHeader, PaypalCheckout, RegisterButton },
})
export default class Pricing extends Vue {
    public product: Product = { id: "", clientId: "", route: "", price: "" };
    public loadingReady: boolean = false;

    public mounted() {
        ProductService.getProduct("profile").then(response => {
            this.product = response;
            this.loadingReady = true;
        });
    }
    public get storeUser(): User | null {
        return this.$store.state.user;
    }

    public get buttonSize(): { w: number; h: number } {
        if (this.$vuetify.breakpoint.lgAndUp) {
            return { w: 316, h: 45 };
        } else return { w: 260, h: 35 };
    }
    public mailSubject(subject: string): string {
        return `mailto:andy@zieglercloud.de?subject=${subject}`;
    }
}
